import { Routes } from "@angular/router";
import { onboardingGuard } from "./core/guards/onboarding.guard";
import { mobileGuard } from "./core/guards/mobile.guard";

export const routes: Routes = [
  { path: "", pathMatch: "full", redirectTo: "onboarding/welcome" },
  {
    path: "mobile-block",
    loadComponent: () =>
      import("./pages/mobile-block/mobile-block.component").then((m) => m.MobileBlockComponent),
  },
  {
    path: "landing",
    loadComponent: () =>
      import("./pages/landing-page/landing-page.component").then((m) => m.LandingPageComponent),
    canActivate: [mobileGuard],
  },
  {
    path: "onboarding/welcome",
    loadComponent: () =>
      import("./pages/onboarding-welcome/onboarding-welcome.component").then(
        (m) => m.OnboardingWelcomeComponent
      ),
    canActivate: [mobileGuard, onboardingGuard],
  },
  {
    path: "onboarding/steps",
    loadComponent: () =>
      import("./pages/onboarding-steps/onboarding-steps.component").then(
        (m) => m.OnboardingStepsComponent
      ),
    canActivate: [mobileGuard, onboardingGuard],
  },
  {
    path: "setup",
    loadComponent: () =>
      import("./features/setup-layout/setup-layout.component").then((m) => m.SetupLayoutComponent),
    canActivate: [mobileGuard, onboardingGuard],
    children: [
      { path: "", pathMatch: "full", redirectTo: "profile" },
      {
        path: "profile",
        loadComponent: () =>
          import("./steps/setup-delivery-profile/setup-delivery-profile.component").then(
            (m) => m.SetupDeliveryProfileComponent
          ),
      },
      {
        path: "delivery-area",
        loadComponent: () =>
          import("./steps/setup-delivery-area/setup-delivery-area.component").then(
            (m) => m.SetupDeliveryAreaComponent
          ),
      },
      {
        path: "payment-methods",
        loadComponent: () =>
          import("./steps/setup-payment-methods/setup-payment-methods.component").then(
            (m) => m.SetupPaymentMethodsComponent
          ),
      },
      {
        path: "schedule",
        loadComponent: () =>
          import("./steps/setup-schedule/setup-schedule.component").then(
            (m) => m.SetupScheduleComponent
          ),
      },
      {
        path: "salon",
        loadComponent: () =>
          import("./steps/setup-salon/setup-salon.component").then((m) => m.SetupSalonComponent),
      },
      {
        path: "menu",
        loadComponent: () =>
          import("./steps/setup-menu/setup-menu.component").then((m) => m.SetupMenuComponent),
      },
      {
        path: "menu/ai",
        loadComponent: () =>
          import("./steps/setup-menu-ai/setup-menu-ai.component").then(
            (m) => m.SetupMenuAIComponent
          ),
      },
      {
        path: "menu/manual",
        loadComponent: () =>
          import("./steps/setup-menu-builder/setup-menu-builder.component").then(
            (m) => m.SetupMenuBuilderComponent
          ),
      },
      {
        path: "printer",
        loadComponent: () =>
          import("./steps/setup-printer/setup-printer.component").then(
            (m) => m.SetupPrinterComponent
          ),
      },
      {
        path: "integration-ifood",
        loadComponent: () =>
          import("./steps/setup-ifood-integration/setup-ifood-integration.component").then(
            (m) => m.SetupIfoodIntegrationComponent
          ),
        data: { title: "Integração iFood" },
      },
      {
        path: "publish",
        loadComponent: () =>
          import("./steps/setup-publish/setup-publish.component").then(
            (m) => m.SetupPublishComponent
          ),
        data: { title: "Divulgar" },
      },
    ],
  },
  { path: "**", redirectTo: "onboarding/welcome" },
];
